// extracted by mini-css-extract-plugin
export var modal = "_kg-0";